const key = import.meta.env.VITE_GEOCODE_API_KEY;

// Google returns US territories as their own country, with a municipality
// (e.g. "San Juan") as administrative_area_level_1.
const US_TERRITORIES = ['AS', 'GU', 'MP', 'PR', 'VI'];

interface Address {
  long_name: string;
  short_name: string;
  types: string[];
}

interface Response {
  results: {
    address_components: Address[];
    types: string[];
  }[];
  status: string;
}

const fetchGeocodeData = async (zipCode: string): Promise<Response> => {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${zipCode}&key=${key}`;
  const res = await fetch(url);
  return res.json();
};

const findComponent = (components: Address[], type: string) =>
  components.find((component) => component.types.includes(type));

export const getStateFromZipCode = async (zipCode: string) => {
  try {
    const data = await fetchGeocodeData(zipCode);

    for (const location of data.results) {
      const components = location.address_components;
      const country = findComponent(components, 'country')?.short_name;

      if (country === 'US') {
        const state = findComponent(
          components,
          'administrative_area_level_1'
        )?.short_name;
        if (state) return state;
      }

      if (country && US_TERRITORIES.includes(country)) {
        return country;
      }
    }
  } catch {
    return;
  }
};
